import type { BlockMath } from 'shared-types';

type LocaleData = BlockMath['locales'][string];

const defaultBlockData = {
  format: 'text' as const
};

const translatable: LocaleData['translatable'] = { text: '' };
const defaultLocaleData: LocaleData = { translatable };

const localePlaceholders = {
  text: '{{ locales.translatable.text }}' as const
};

export const defaults = {
  defaultBlockData,
  defaultLocaleData,
  localePlaceholders
};

export const blockMathjaxData: BlockMath = {
  ...defaultBlockData,
  ...localePlaceholders,
  locales: new Proxy({} as BlockMath['locales'], {
    get: (locales, languageVersion: string) => {
      return (locales[languageVersion] = defaultLocaleData);
    }
  })
};
